export class TRPCAuthError extends Error {
  public readonly url: URL | RequestInfo;
  public readonly status: number;

  constructor({
    url,
    status,
  }: {
    url: URL | RequestInfo;
    status: number;
  }) {
    super(`Authentication error (status ${status})`);
    this.name = "TRPCAuthError";
    this.url = url;
    this.status = status;
  }
}
